export const menuList = [{
  header: 'REPORTS',
  submenu: [{
    name: 'Generate Reports',
    url: '/generate-reports',
    access: 'REPORTS'
  }]
}, {
  header: 'FINANCES',
  submenu: [{
    name: 'Request Settlement',
    url: '/request-settlement',
    access: "REQUEST_SETTLEMENT",
    permission: true
  }, {
    name: 'OTC Settlement Request',
    url: '/otc-settlement',
    access: "REQUEST_SETTLEMENT",
    permission: true
  }]
}, {
  header: 'SETTINGS',
  submenu: [{
    name: 'My Account',
    url: '/my-account',
    access: 'MY_ACCOUNT'
  }, {
    name: 'Bank Codes',
    url: '/bank-codes',
    access: 'BANKLIST'
  }]
}, {
  header: 'REFUNDS',
  submenu: [{
    name: 'Refunds',
    url: '/refunds',
    access: "REFUND"
  }]
}, {
  header: "SOFTWARE INTEGRATION",
  submenu: [{
    name: "API",
    url: "/docs",
    access: "API"
  }]
}];
